var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubContractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.6,31c-2.5-1-3.8-3-3.4-5.2c0.4-2.3,2.2-3.9,4.4-3.9c2.1-0.1,4.1,1.5,4.6,3.5c0.6,2.4-0.6,4.3-3.4,5.6 c1.4,0,2.7,0.1,3.9,0.4c0.9,0.2,1.8,0.6,2.6,1.2c0.7,0.5,1.1,1.2,1.1,2.2c0,1,0,2,0,3.1c0,0.3-0.1,0.4-0.4,0.4c-2,0-4,0-6,0 c-0.2,0-0.3,0-0.4-0.2c-0.4-0.9-0.8-1.8-1.2-2.7c-0.1-0.3,0-0.4,0.1-0.6c0.5-0.7,1-1.3,1.6-2c-1.6,0-3.2,0-4.8,0 c0.5,0.7,1,1.4,1.6,2c0.2,0.2,0.2,0.4,0.1,0.7c-0.4,0.8-0.7,1.6-1,2.5c-0.1,0.3-0.2,0.4-0.5,0.4c-2,0-3.9,0-5.9,0 c-0.4,0-0.4-0.1-0.4-0.4c0-1,0-2,0-3c0-0.9,0.3-1.5,1-2.1c1.3-1,2.9-1.4,4.5-1.6C22.2,31,22.9,31,23.6,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,31c1.8-1.6,3.5-3.2,5.3-4.7c1.1,2.1,2.2,4.1,3.4,6.2c-0.8-0.1-1.5-0.2-2.1-0.4c-0.3-0.1-0.4,0-0.4,0.3 c0.3,6.1,5.1,11.2,11.2,11.8c5,0.5,9-1.5,11.8-5.6c0.2-0.3,0.4-0.3,0.7-0.1c0.8,0.5,1.5,0.9,2.3,1.4c0.3,0.2,0.3,0.3,0.1,0.6 c-2.8,4.3-6.7,6.8-11.8,7.3c-7.6,0.8-14.5-3.5-17-10.6c-0.6-1.7-0.9-3.5-0.9-5.3c0-0.4-0.2-0.5-0.5-0.6C7.5,31.2,6.9,31.1,6.1,31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,32.6c-1.7,1.6-3.4,3-5,4.5c-0.2,0.2-0.3,0.1-0.4-0.1c-1-2-2.1-3.9-3.2-5.9c0.9,0.1,1.7,0.3,2.5,0.4 c0-1.7-0.3-3.3-1-4.8c-2.1-4.5-5.6-7-10.5-7.4c-4.8-0.4-8.6,1.6-11.4,5.6c-0.3,0.4-0.4,0.4-0.8,0.2c-0.7-0.4-1.4-0.9-2.1-1.2 c-0.5-0.2-0.4-0.5-0.2-0.8c2.3-3.4,5.4-5.7,9.4-6.7c9.1-2.4,18.1,3.3,19.9,12.5c0.2,1,0.3,2,0.3,3c0,0.3,0.1,0.4,0.4,0.5 C41.9,32.3,42.6,32.4,43.4,32.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9,8.7c1.2,0,2.4,0.3,3.5,1c0.7,0.4,1.1,1,1.1,1.9c0,0.6,0,1.2,0,1.8c0,0.3,0,0.4-0.4,0.4c-4,0-8,0-12,0 c-0.3,0-0.4-0.1-0.4-0.4c0-0.7,0-1.5,0-2.2c0-0.7,0.5-1.2,1-1.5c1.1-0.7,2.3-1,3.5-1C24.4,8.5,25.6,8.5,26.9,8.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.2,8.7c1.3,0,2.4,0.3,3.5,1c0.7,0.4,1.1,1,1,1.9c0,0.6,0,1.2,0,1.8c0,0.3-0.1,0.4-0.4,0.4c-4,0-8,0-12,0 c-0.3,0-0.4-0.1-0.4-0.4c0-0.6,0-1.2,0-1.8c-0.1-0.8,0.3-1.4,1-1.8c1.1-0.7,2.3-1,3.5-1C39.7,8.5,40.9,8.5,42.2,8.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,8.7c1.2,0,2.4,0.3,3.5,1c0.7,0.4,1.1,1,1,1.9c0,0.6,0,1.2,0,1.8c0,0.3-0.1,0.4-0.4,0.4c-4,0-8,0-12,0 c-0.3,0-0.4-0.1-0.4-0.4c0-0.6,0-1.2,0-1.8c-0.1-0.9,0.4-1.5,1.1-1.9c1.1-0.7,2.2-0.9,3.5-1C9.1,8.5,10.3,8.5,11.6,8.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,8.5c-1.6-0.4-2.6-2-2.4-3.5C6.6,3.2,8,2,9.7,2c1.7,0,3.1,1.2,3.3,3c0.2,1.5-0.9,3.1-2.4,3.5 C10,8.7,9.4,8.7,8.8,8.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,8.5c-1.6-0.4-2.6-2-2.4-3.5C37.3,3.2,38.6,2,40.3,2c1.7,0,3.1,1.2,3.3,2.9c0.2,1.6-0.9,3.1-2.4,3.5 C40.6,8.7,40,8.7,39.4,8.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,8.5c-1.6-0.4-2.6-2-2.4-3.5C22,3.2,23.3,2,25,2c1.7,0,3.1,1.2,3.3,3c0.2,1.5-0.9,3.1-2.4,3.5 C25.3,8.7,24.7,8.7,24.1,8.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.5,19.8c-0.7,0-1.3-0.5-1.3-1.2c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.5,1.3,1.2C38.8,19.2,38.2,19.8,37.5,19.8 z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,17c-0.7,0-1.3-0.5-1.3-1.2c0-0.7,0.5-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C10.7,16.4,10.2,17,9.5,17z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,15.8c0,0.7-0.6,1.3-1.3,1.2c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.2,1.3-1.2C40.8,14.5,41.3,15.1,41.3,15.8 z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,17.3c0.7,0,1.3,0.5,1.3,1.2c0,0.7-0.5,1.3-1.2,1.3c-0.7,0-1.3-0.6-1.3-1.3C10.7,17.9,11.3,17.3,12,17.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,8.5c0.6,0.2,1.2,0.1,1.8,0c0.3,0.3,0.7,0,1,0.2c-1.2,0-2.5,0-3.7,0C8.1,8.5,8.5,8.7,8.8,8.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,8.5c0.6,0.2,1.2,0.1,1.8,0c0.3,0.3,0.7,0,1,0.2c-1.2,0-2.5,0-3.7,0C23.4,8.5,23.8,8.7,24.1,8.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,8.5c0.6,0.2,1.2,0.1,1.8,0c0.3,0.3,0.7,0,1,0.2c-1.2,0.1-2.5,0-3.7,0C38.7,8.5,39.1,8.7,39.4,8.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubContractor);
export default __webpack_public_path__ + "static/media/sub-contractor.4a01a6117c00398b51943da1b8dd90bb.svg";
export { ForwardRef as ReactComponent };